// entry/actions.js
import actionTypes from './actionTypes';

//public actions
const displayForm = (form) => ({
    type: actionTypes.DISPLAY_FORM,
    payload: {
        form
    }
});

const changeValue = (name, value) => ({
    type: actionTypes.CHANGE_VALUE,
    payload: {
        name,
        value
    }
});

const resetValues = () => ({
    type: actionTypes.RESET_VALUES,
    payload: {
        formData: {
            firstName: '',
            lastName: '',
            title: '',
            mediaAffiliation: '',
            email: '',
            password: ''
        }
    }
});

const requestLogin = () => ({
    type: actionTypes.REQUEST_LOGIN
});

const loginResponse = (success, authToken, errors) => ({
    type: actionTypes.LOGIN_RESPONSE,
    payload: {
        success,
        authToken,
        errors
    }
});

const requestForgotPassword = () => ({
    type: actionTypes.REQUEST_FORGOT_PASSWORD
});

const forgotPasswordResponse = (success, errors) => ({
    type: actionTypes.FORGOT_PASSWORD_RESPONSE,
    payload: {
        success,
        errors
    }
});

const requestAccountRequest = () => ({
    type: actionTypes.REQUEST_ACCOUNT_REQUEST
});

const accountRequestResponse = (success, errors) => ({
    type: actionTypes.ACCOUNT_REQUEST_RESPONSE,
    payload: {
        success,
        errors
    }
});

export default {
    changeValue,
    displayForm,
    resetValues,
    requestLogin,
    loginResponse,
    requestForgotPassword,
    forgotPasswordResponse,
    requestAccountRequest,
    accountRequestResponse
};